import styled from 'styled-components';
import { Button, media } from '@minerva-analytics/pantheon';

import { WHITE, BLACK } from 'root/theme';

const ShareButton = styled(Button)`
  background: ${(props) => props.background || BLACK};
  border: none;
  border-radius: 50%;
  display: inline-block;
  margin: 1rem 0.5rem;
  padding: 1rem;
  width: 55px;
  height: 55px;

  & svg {
    color: ${WHITE};
    vertical-align: middle;
  }

  ${media.phone`
    padding: 0.75rem;
  `}
`;

export default ShareButton;
